import { Create, SimpleForm, TextInput, SelectInput, required } from 'react-admin';

export const ServiceCreate = () => (
  <Create>
    <SimpleForm>
      <TextInput source="name" label="Service Name" validate={required()} />
      <TextInput source="description" label="Description" multiline />
      <TextInput source="category" label="Category" />
      <SelectInput source="status" defaultValue="Active" choices={[
        { id: 'Active', name: 'Active' },
        { id: 'Inactive', name: 'Inactive' },
      ]} />
    </SimpleForm>
  </Create>
);
